export const RECENT_ORDERS_CONFIG = {
  MAX_RECENT_ORDERS: 20,
} as const;
